var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuyStandingCircle = function SvgGuyStandingCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 231,
    height: 241,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#guy-standing-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M89.359 241c49.351 0 89.358-7.047 89.358-15.739s-40.007-15.74-89.358-15.74S0 216.568 0 225.261C0 233.953 40.007 241 89.359 241M143.669 174.144c48.232 0 87.331-38.984 87.331-87.072S191.901 0 143.669 0 56.338 38.983 56.338 87.072c0 48.088 39.1 87.072 87.331 87.072"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M143.669 158.953c39.817 0 72.095-32.182 72.095-71.881s-32.278-71.88-72.095-71.88-72.095 32.182-72.095 71.88c0 39.699 32.278 71.881 72.095 71.881",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M143.669 145.985c32.633 0 59.088-26.376 59.088-58.912S176.302 28.16 143.669 28.16 84.581 54.536 84.581 87.073s26.455 58.912 59.088 58.912",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M143.669 129.31c23.397 0 42.365-18.911 42.365-42.239s-18.968-42.239-42.365-42.239-42.365 18.911-42.365 42.24c0 23.327 18.967 42.238 42.365 42.238",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0CDE1",
    d: "M57.111 94.863s-6.866 19.269-3.814 26.115 7.883 13.438 7.883 13.438-1.78-38.285-4.069-39.553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M57.111 94.863s-6.866 19.269-3.814 26.115 7.883 13.438 7.883 13.438-1.78-38.285-4.069-39.553",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M61.943 139.488s-.508 4.817-.763 5.07c-.254.254.255.761 0 1.522-.254.76-.508 1.774 0 2.028.509.253-2.797 22.565-2.797 22.565s-8.138 10.649-4.832 27.382l1.017 16.988s7.884.507 7.884-2.282c0 0-.509-3.296-.509-4.818s1.272-1.521.509-2.281-.763-1.268-.763-1.268 1.271-1.014 1.017-1.268c-.254-.253 2.289-18.255 2.289-18.255s2.797-2.789 2.797-4.31v-1.521s1.271-3.296 1.271-3.55c0-.253 6.866-15.719 6.866-15.719l2.797 11.156 3.052 15.973s1.526 14.451 4.577 20.029c0 0 5.34 18.255 5.34 17.748s8.901-1.775 8.647-4.056c-.255-2.282-5.34-34.228-5.34-34.228l1.27-47.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M55.077 213.775s-6.866 13.438-2.289 13.945c4.578.507 6.358.507 8.392-1.522 1.112-1.108 3.365-2.596 5.178-3.717a6.7 6.7 0 0 0 2.504-2.719 6.66 6.66 0 0 0 .673-3.629c-.134-1.241-.599-2.263-1.743-2.358-3.052-.254-6.612-3.043-6.612-3.043zM92.967 223.664s-6.866 13.437-2.289 13.944c4.578.507 6.358.507 8.392-1.521 1.112-1.109 3.364-2.597 5.178-3.718a6.663 6.663 0 0 0 3.177-6.348c-.134-1.24-.599-2.262-1.743-2.357-3.052-.254-6.612-3.043-6.612-3.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M85.71 72.874c5.904 0 10.69-4.771 10.69-10.657s-4.786-10.658-10.69-10.658c-5.903 0-10.69 4.771-10.69 10.658s4.787 10.657 10.69 10.657"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M78.839 65.719s-7.636 14.007-8.247 14.007 13.744 4.568 13.744 4.568 3.97-13.399 4.581-14.617z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0CDE1",
    d: "M90.551 81.047s-15.258-8.367-16.783-8.114S55.967 87.385 56.22 93.217c.255 5.831 2.289 15.466 2.289 15.466s.763 26.875 2.289 27.128c1.525.254-.255 4.818.254 4.818s35.601 0 35.856-.761c.254-.761-6.358-58.821-6.358-58.821"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M99.07 141.262s4.832 14.705.763 14.198-5.849-12.677-5.849-12.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0CDE1",
    d: "M86.101 80.159s-9.409 2.028-7.883 14.705 4.323 25.354 4.323 25.354l9.409 20.537 1.017 3.803 6.866-1.775-5.086-29.41s-1.78-31.44-4.069-32.454a9.9 9.9 0 0 0-4.577-.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m80.38 119.838 11.697 20.79-9.855-21.907z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "m96.353 59.077.035-.815 1.625.404a1.8 1.8 0 0 0-.728-1.333l1.73-.097a18.7 18.7 0 0 0-5.454-5.123 18.7 18.7 0 0 0-7.036-2.574c-3.745-.54-7.913.242-10.48 3.013-1.246 1.343-2.029 3.052-2.585 4.796-1.025 3.21-1.234 7.038.904 9.648 2.172 2.653 5.967 3.172 9.386 3.5 1.203.116 2.464.224 3.579-.242a8.56 8.56 0 0 0-.48-3.765 2.5 2.5 0 0 1-.254-1.199c.152-1.014 1.509-1.27 2.528-1.133 1.02.138 2.245.347 2.914-.431.462-.536.435-1.317.496-2.02.166-1.916 3.802-2.228 3.82-2.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5DD39E",
    d: "M161.917 227.426c6.879 0 12.455-5.56 12.455-12.418s-5.576-12.418-12.455-12.418-12.455 5.56-12.455 12.418 5.576 12.418 12.455 12.418M15.641 223.094c6.88 0 12.455-5.56 12.455-12.418s-5.576-12.418-12.455-12.418c-6.878 0-12.455 5.56-12.455 12.418s5.577 12.418 12.455 12.418"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5DD39E",
    d: "M15.641 203.167c4.96 0 8.98-4.008 8.98-8.953s-4.02-8.952-8.98-8.952c-4.959 0-8.979 4.008-8.979 8.952 0 4.945 4.02 8.953 8.98 8.953"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5DD39E",
    d: "M15.641 186.707c3.52 0 6.373-2.845 6.373-6.353 0-3.509-2.853-6.354-6.373-6.354s-6.372 2.845-6.372 6.354 2.853 6.353 6.372 6.353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "guy-standing-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h231v241H0z"
  })))));
};
export default SvgGuyStandingCircle;